/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Session_RepeatedInputs */

const en_us2_import_session_repeated = /** @type {(inputs: Import_Session_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same workout appears twice in the file.`)
};

const pt_br2_import_session_repeated = /** @type {(inputs: Import_Session_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mesmo treino aparece duas vezes no arquivo.`)
};

const es_419_import_session_repeated = /** @type {(inputs: Import_Session_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mismo entrenamiento aparece dos veces en el archivo.`)
};

const pt_pt2_import_session_repeated = /** @type {(inputs: Import_Session_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mesmo treino aparece duas vezes no ficheiro.`)
};

const fr_fr2_import_session_repeated = /** @type {(inputs: Import_Session_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La même séance apparaît deux fois dans le fichier.`)
};

const de_de2_import_session_repeated = /** @type {(inputs: Import_Session_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasselbe Training kommt in der Datei zweimal vor.`)
};

const it_it2_import_session_repeated = /** @type {(inputs: Import_Session_RepeatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo stesso allenamento compare due volte nel file.`)
};

/**
* | output |
* | --- |
* | "The same workout appears twice in the file." |
*
* @param {Import_Session_RepeatedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const import_session_repeated = /** @type {((inputs?: Import_Session_RepeatedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Session_RepeatedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_import_session_repeated(inputs)
	if (locale === "es-419") return es_419_import_session_repeated(inputs)
	if (locale === "pt-PT") return pt_pt2_import_session_repeated(inputs)
	if (locale === "fr-FR") return fr_fr2_import_session_repeated(inputs)
	if (locale === "de-DE") return de_de2_import_session_repeated(inputs)
	if (locale === "it-IT") return it_it2_import_session_repeated(inputs)
	return en_us2_import_session_repeated(inputs)
});
export { import_session_repeated as "import.session_repeated" }